import React from 'react';
import { useAdobeDataLayer, PageNames } from '../../../hooks/useAdobeDataLayer';
import Intro from '../../../components/Redesign/Intro';
import MarriottDigitalHero from '../../../components/Redesign/MarriottDigitalHero';
import MarriottDigitalCards from '../../../components/Redesign/MarriottDigitalCards';
import MarriottOnline from '../../../components/Redesign/MarriottOnline';
import MarriottBonvoyApp from '../../../components/Redesign/MarriottBonvoyApp';
import MemberEmails from '../../../components/Redesign/MemberEmails';
import ContactBanner from '../../../components/Redesign/ContactBanner';
import bgImageAvif from 'url:../../../assets-optimized/redesign/solutions/marriott-digital/about_placements.avif';
import bgImageWebp from 'url:../../../assets-optimized/redesign/solutions/marriott-digital/about_placements.webp';
import bgImage from 'url:../../../assets-optimized/redesign/solutions/marriott-digital/about_placements.png';
import SolutionsNavigation from '../../../components/Redesign/SolutionsNavigation';

const MarriottDigital = () => {
    const { sendPageView } = useAdobeDataLayer();

    React.useEffect(() => {
        sendPageView(PageNames.MarriottDigital);
    }, [sendPageView]);

    return (
        <div className='marriott-digital-page'>
            <MarriottDigitalHero />

            <Intro className='intro-custom-size'>
                Travel begins to take shape here. In the <br className="mobile-only" />moments of dreaming,<br className="mobile-only" /> comparing, and committing this is <br className="mobile-only" />where your brand becomes  {' '}
                <span className='audience-pill cs-intro-pill'>
                    <span className='cs-lightning-wrapper'>
                        <svg viewBox='0 0 24 24' className='cs-lightning-bolt'>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" fill="none" stroke="currentColor" strokeWidth="2" />
                        </svg>
                    </span>
                    part of the decision, <br className="mobile-only" />not a distraction from it.
                </span>
            </Intro>

            {/* <MarriottDigitalCards /> */}

            <MarriottOnline />

            <MarriottBonvoyApp />

            <MemberEmails />

            <ContactBanner className="contact-banner-alt" title="Bring your brand into the journey" bgImage={bgImage} bgImageAvif={bgImageAvif} bgImageWebp={bgImageWebp} ctaStyle="black" />

            <SolutionsNavigation
                prevTitle="ON PROPERTY"
                prevLink="/solutions/on-property"
                nextTitle="OFFSITE DIGITAL"
                nextLink="/solutions/offsite-digital"
            />

        </div>
    );
};

export default MarriottDigital;
